const STORAGE_KEY = 'amr-booking-search-v1';

export function saveBookingSearch(search) {
  if (!isValidSearch(search)) return;
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
    ...search,
    bookingOptions: normalizeBookingOptions(search.bookingOptions),
  }));
}

export function readBookingSearch() {
  try {
    const value = window.sessionStorage.getItem(STORAGE_KEY);
    if (!value) return null;

    const search = JSON.parse(value);
    if (!isValidSearch(search) || hasExpiredQuotes(search.availability.residences)) {
      clearBookingSearch();
      return null;
    }

    return {
      ...search,
      bookingOptions: normalizeBookingOptions(search.bookingOptions),
    };
  } catch {
    clearBookingSearch();
    return null;
  }
}

export function clearBookingSearch() {
  window.sessionStorage.removeItem(STORAGE_KEY);
}

function isValidSearch(search) {
  return Boolean(
    search
    && typeof search === 'object'
    && typeof search.checkInDateLocalized === 'string'
    && typeof search.checkOutDateLocalized === 'string'
    && Number.isInteger(search.adultsCount)
    && Number.isInteger(search.childrenCount)
    && Array.isArray(search.childrenAges)
    && search.childrenAges.length === search.childrenCount
    && Array.isArray(search.availability?.residences)
  );
}

function hasExpiredQuotes(quotes) {
  const now = Date.now();
  return quotes.some((quote) => quote?.expiresAt && Date.parse(quote.expiresAt) <= now);
}

function normalizeBookingOptions(value) {
  return {
    privateParking: value?.privateParking === true,
    babyCot: value?.babyCot === true,
    highChair: value?.highChair === true,
  };
}

export { STORAGE_KEY as BOOKING_SEARCH_STORAGE_KEY };
